import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityProductsWithoutCostResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

const DEFAULT_PER_PAGE = 20;

export interface UseProductsWithoutCostParams {
  search?: string;
  page?: number;
  per_page?: number;
}

export const useProductsWithoutCost = (enabled: boolean, params?: UseProductsWithoutCostParams) => {
  const page = params?.page ?? 1;
  const perPage = params?.per_page ?? DEFAULT_PER_PAGE;
  const search = params?.search?.trim() ?? '';

  return useQuery<ProfitabilityProductsWithoutCostResponse, Error>({
    queryKey: ['profitability', 'products-without-cost', search, page, perPage],
    queryFn: () =>
      adapter.getProductsWithoutCost({
        search: search || undefined,
        page,
        per_page: perPage,
      }),
    enabled,
    staleTime: 30 * 1000,
  });
};
